// services/everpro/everpro-order/createV3.ts — Create Shipment Order V3 per-brand via S2 proxy
// V3 memakai sub_district_id (akurasi lebih tinggi dari kode pos V2). Dipakai saat
// everproConfig.useV3 aktif — kalau gagal, caller harus fallback ke V2 (createEverproOrder).
import { withRetry } from '../../../utils/retryLogic';
import { everproFetch } from '../everpro-auth';
import type { CreateEverproOrderResult, CreateEverproOrderV3Params } from '../everpro-types';
import { buildCreateOrderV3Body } from './createV3Body.js';

export async function createEverproOrderV3(
  params: CreateEverproOrderV3Params,
  brandId: string,
): Promise<CreateEverproOrderResult> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  const body = buildCreateOrderV3Body(params);

  const res = await withRetry(() => everproFetch(brandId, '/shipment/v3/orders', {
    method: 'POST',
    body: JSON.stringify(body),
  }), {
    maxRetries: 2,
    initialDelayMs: 1000,
    backoffMultiplier: 2,
    shouldRetry: (err) => err instanceof TypeError,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    // 504 = timeout, BUKAN pasti gagal (lihat create.ts) — booking ulang aman.
    if (res.status === 504) {
      throw new Error(message || 'Everpro timeout (504) — order mungkin sudah tercipta. Booking ulang aman: sistem cek duplikat otomatis sebelum membuat order baru.');
    }
    throw new Error(message || `Everpro create order V3: ${res.status} ${res.statusText}`);
  }

  const json = await res.json();
  const data = json?.data ?? {};
  return {
    clientOrderNo: data.client_order_no ?? params.clientOrderNo,
    shipmentOrderNo: data.shipment_order_no,
    actualPrice: data.actual_price,
    actualCodPrice: data.actual_cod_price,
  };
}
